"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.n3Pane = void 0;
var UI = _interopRequireWildcard(require("solid-ui"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/*      Notation3 content Pane
 **
 **  This pane shows the content of a particular RDF resource
 ** or at least the RDF semantics we attribute to that resource,
 ** in generated N3 syntax.
 */

var ns = UI.ns;
var n3Pane = exports.n3Pane = {
  icon: UI.icons.originalIconBase + 'w3c/n3_smaller.png',
  name: 'n3',
  audience: [ns.solid('Developer')],
  label: function label(subject, context) {
    var store = context.session.store;
    if ('http://www.w3.org/2007/ont/link#ProtocolEvent' in store.findTypeURIs(subject)) {
      return null;
    }
    var n = store.statementsMatching(undefined, undefined, undefined, subject).length;
    if (n === 0) return null;
    return 'Data (' + n + ') as N3';
  },
  render: function render(subject, context) {
    var myDocument = context.dom;
    var kb = context.session.store;
    var div = myDocument.createElement('div');
    div.setAttribute('class', 'n3Pane');
    // Because of smushing etc, this will not be a copy of the original source
    // We could instead either fetch and re-parse the source,
    // or we could keep all the pre-smushed triples.
    var sts = kb.statementsMatching(undefined, undefined, undefined, subject); // @@ slow with current store!
    /*
    var kludge = kb.formula([]) // No features
    for (var i=0; i< sts.length; i++) {
        s = sts[i]
        kludge.add(s.subject, s.predicate, s.object)
    }
    */
    var sz = UI.rdf.Serializer(kb);
    sz.suggestNamespaces(kb.namespaces);
    sz.setBase(subject.uri);
    var str = sz.statementsToN3(sts);
    var pre = myDocument.createElement('PRE');
    pre.appendChild(myDocument.createTextNode(str));
    div.appendChild(pre);
    return div;
  }
};
//# sourceMappingURL=n3Pane.js.map